import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'providers/nz/moe/v4/rollreturns';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('nzRollReturns/', '')
      .toLowerCase();
  }
}
